import React from "react";
import cx from "classnames";
import t from "Utils/translation";
import s from "./helpTooltip.scss";
import { Icon, helpFill } from "Icons/index";

export default class HelpTooltip extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowing: false
    };
  }

  showHelpContent() {
    this.setState({
      isShowing: true
    });
  }

  hideHelpContent() {
    this.setState({
      isShowing: false
    });
  }

  render() {
    let { children, id, className } = this.props;

    return (
      <div id={id} className={cx(className, s.helpContainer)}>
        <Icon
          svg={helpFill}
          className={s.iconBtn}
          width="0.875rem"
          onMouseEnter={this.showHelpContent.bind(this)}
          onMouseLeave={this.hideHelpContent.bind(this)}
        />
        <div
          className={cx(s.helpWrap, {
            [s.showWrap]: this.state.isShowing
          })}
        >
          <Icon
            svg={helpFill}
            className={s.icon}
            width="3rem"
            height="3rem"
            onMouseEnter={this.showHelpContent.bind(this)}
            onMouseLeave={this.hideHelpContent.bind(this)}
          />
          <div className={s.helpContent}>
            {children.map(child => (
              <div key={child.title || child.description}>
                {child.title && <div className={s.helpTitle}>{child.title}</div>}
                <div
                  className={s.helpDesciption}
                  dangerouslySetInnerHTML={{
                    __html: child.description
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
